import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router";

import { useEvaluation } from "@/hooks/useEvaluation/useEvaluation";
import { EvaluationEmptyState } from "../EvaluationEmptyState";

import { LoadingView } from "@/components/LoadingView";
import { useHasCcAccess } from "@/hooks/useHasCcAccess/useHasCcAccess";
import { Flex } from "@aircall/tractor";
import { EvaluationScorecards } from "../EvaluationScorecards/EvaluationScorecards";

export function EvaluationEmptyView() {
  const { t } = useTranslation();
  const hasCcAccess = useHasCcAccess();

  const { callId } = useParams();

  const { evaluation, loading } = useEvaluation(callId);

  if (loading) {
    return (
      <Flex h="100%" justifyContent="center" alignItems="center">
        <LoadingView mt={0} />
      </Flex>
    );
  }

  if (evaluation && !loading) {
    return <Navigate to="result" />;
  }

  // This condition is for the Agent view
  if (!hasCcAccess) {
    return (
      <EvaluationEmptyState title={t("evaluation.empty_view.title_agent")} />
    );
  }

  return (
    <Flex
      h="100%"
      justifyContent="center"
      alignItems="center"
      data-test="evaluation-empty-section"
    >
      <EvaluationScorecards />
    </Flex>
  );
}
